import React from "react";

// mui components
import { MenuItem, Select } from "@mui/material";

// custom components
import Body3 from "../../typography/body-03";

// mui icons
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// custom styles
import styles from "./index.module.scss";

const SingleSelect = ({
	id,
	label,
	displayEmpty,
	value,
	handleChange,
	options,
	extraClass,
}) => {
	const customClass = `${styles.singleSelect} ${extraClass}`;

	return (
		<Select
			labelId={`simple-select-${id}-label`}
			id={`simple-select-${id}`}
			label={label}
			displayEmpty={displayEmpty}
			IconComponent={ExpandMoreIcon}
			value={value}
			onChange={handleChange}
			className={customClass}
		>
			<MenuItem value="" disabled>
				<Body3 text="Select" extraClass={styles.selectText} />
			</MenuItem>
			{options.map((item, index) => (
				<MenuItem value={item.value} key={index}>
					<Body3 text={item.label} extraClass={styles.selectText} />
				</MenuItem>
			))}
		</Select>
	);
};

export default SingleSelect;
